<template>
  <CHeader id="header" with-subheader>
    <CHeaderBrand class="mx-auto d-lg-none" :to="{ name: 'Home' }">
      <CIcon name="peIcon" height="48" alt="Logo" />
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem v-for="link in navLinks" :key="link.name" class="px-3">
        <CHeaderNavLink :to="link.to">
          {{ link.name }}
        </CHeaderNavLink>
      </CHeaderNavItem>
    </CHeaderNav>
    <CHeaderNav class="mr-auto">
      <div class="nav-search">
        <TheHeaderSearch
          v-model="searchValue"
          @search="searching = $event"
          @clear="clear"
          @on-results="searchResults = $event"
        />
      </div>
      <div class="nav-search-results">
        <TheHeaderSearchResults
          v-if="searchValue"
          :loading="searching"
          :search-value="searchValue"
          :data="searchResults"
          @on-select="handleSelect"
        />
      </div>
    </CHeaderNav>
    <CHeaderNav>
      <TheHeaderDropdownHelp />
    </CHeaderNav>
    <CHeaderNav>
      <TheHeaderDropdownAccnt />
    </CHeaderNav>

    <CSubheader>
      <RBreadcrumbRouter class="border-0 mb-0" />
    </CSubheader>
  </CHeader>
</template>

<script>
import { RBreadcrumbRouter } from '@/components/breadcrumbs'

import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import TheHeaderDropdownHelp from './TheHeaderDropdownHelp'
import TheHeaderSearch from './TheHeaderSearch'
import TheHeaderSearchResults from './TheHeaderSearchResults'

// Header navigation links for staff users
const staffNav = [
  { name: 'Customers', to: { name: 'CompanyList' } },
  { name: 'Staff', to: { name: 'KPIReports' } }
]
// Header navigation links for non-staff users
const userNav = [
  { name: 'Home', to: { name: 'Home' } }
]

export default {
  name: 'TheHeader',
  components: {
    RBreadcrumbRouter,
    TheHeaderSearch,
    TheHeaderSearchResults,
    TheHeaderDropdownAccnt,
    TheHeaderDropdownHelp
  },
  data () {
    return {
      searchValue: '',
      searching: false,
      searchResults: []
    }
  },
  computed: {
    navLinks () {
      return this.$store.getters['auth/isStaff'] ? staffNav : userNav
    }
  },
  methods: {
    /**
     * Clears search value input and results.
     */
    clear () {
      this.searchValue = ''
      this.searchResults = []
    },
    /**
     * onSelect handler for navigation search
     * results link click.
     *
     * @param {String} value - company/property name
     */
    handleSelect (value) {
      this.clear()
    }
  }
}
</script>

<style lang="scss" scoped>
#header {
  box-shadow: none;

  .nav-search {
    display: inline-block;
    padding-top: 1rem;
  }

  .nav-search-results {
    padding-top: 2rem;
    position: absolute;
  }

  .c-header-nav-item {
    height: 100%;
    display: flex;
    align-items: center;

    .router-link-active {
      padding: 5px 10px;
      /* Optional: add padding for better visual */
      border-radius: 4px;
      /* Optional: rounded corners */
      background-color: $primary;
    }
  }
}
</style>
